import { render } from "./store_add.vue?vue&type=template&id=d7c3fdd8"
import script from "./store_add.vue?vue&type=script&lang=js"
export * from "./store_add.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__